import { c as _c } from "react/compiler-runtime";
import { CardLayout } from "@components/progress-overview/card-layout";
import { ErrorCard } from "@components/progress-overview/error-card";
import { FontWeights, LinearProgress, RemainingTimeLabel } from "@flat-ui";
import { BackgroundTaskState } from "@faro-lotv/service-wires";
import { useCancelUpload } from "@hooks/upload-tasks/use-cancel-upload";
import { Stack } from "@mui-wrapper";
import { getProjectByIdSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { DEFAULT_TEXT_FONT_SIZE } from "@styles/common-styles";
import { PALETTE_VARS } from "@styles/palette-vars";
/** Renders a task in the menu card to notify the user of a progress item */
export function ProgressCard(t0) {
  const $ = _c(32);
  const {
    task,
    isDevMode
  } = t0;
  let t1;
  if ($[0] !== task.context.projectId) {
    t1 = getProjectByIdSelector(task.context.projectId);
    $[0] = task.context.projectId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const project = useAppSelector(t1);
  const cancelUploadTask = useCancelUpload();
  if (task.status === BackgroundTaskState.failed) {
    let t2;
    if ($[2] !== task) {
      t2 = <ErrorCard task={task} />;
      $[2] = task;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  const t2 = project?.name;
  let t3;
  if ($[4] !== cancelUploadTask || $[5] !== task.id) {
    t3 = [{
      name: "Cancel Upload",
      callback: () => void cancelUploadTask(task.id),
      color: "error"
    }];
    $[4] = cancelUploadTask;
    $[5] = task.id;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = task.progress > 0 ? "determinate" : "indeterminate";
  let t5;
  if ($[7] !== t4 || $[8] !== task.progress) {
    t5 = <LinearProgress value={task.progress} variant={t4} />;
    $[7] = t4;
    $[8] = task.progress;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      justifyContent: "space-between",
      fontSize: DEFAULT_TEXT_FONT_SIZE,
      color: "text.primary",
      alignItems: "center"
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== task.expectedEnd) {
    t7 = task.expectedEnd && <> (<RemainingTimeLabel expectedEnd={task.expectedEnd} sx={{
        color: "text.primary",
        fontWeight: FontWeights.SemiBold
      }} />)</>;
    $[11] = task.expectedEnd;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <div>Uploading...  {t7}</div>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = isDevMode ? PALETTE_VARS.tertiary.main : undefined;
  let t10;
  if ($[15] !== t9) {
    t10 = {
      color: t9
    };
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== isDevMode || $[18] !== task.speedMBps) {
    t11 = isDevMode && task.speedMBps && `${task.speedMBps.toFixed(2)} MB/s`;
    $[17] = isDevMode;
    $[18] = task.speedMBps;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11) {
    t12 = <var style={t10}> {" "}{t11}</var>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t8) {
    t13 = <Stack direction="row" sx={t6}>{t8}{t12}</Stack>;
    $[23] = t12;
    $[24] = t8;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13 || $[27] !== t2 || $[28] !== t3 || $[29] !== t5 || $[30] !== task.fileName) {
    t14 = <CardLayout name={task.fileName} projectName={t2} menu={t3}>{t5}{t13}</CardLayout>;
    $[26] = t13;
    $[27] = t2;
    $[28] = t3;
    $[29] = t5;
    $[30] = task.fileName;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
}